import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default function ImunisIssuerIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" d="M12 17.15a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm0-13.31a1.5 1.5 0 1 1 0 3.02 1.5 1.5 0 0 1 0-3.02Zm.92 5.3a.92.92 0 1 0-1.84 0 .92.92 0 0 0 1.84 0Zm1.61.63a.92.92 0 1 1 0 1.84.92.92 0 0 1 0-1.84Zm-4.13.92a.92.92 0 1 0-1.85 0 .92.92 0 0 0 1.84 0Zm1.6 3.64a.92.92 0 1 1 0 1.85.92.92 0 0 1 0-1.85Zm3.45-.73a.92.92 0 1 0-1.84 0 .92.92 0 0 0 1.84 0Zm-5.98-.92a.92.92 0 1 1 0 1.85.92.92 0 0 1 0-1.85Zm-1.8-3.93a1.5 1.5 0 1 0-3.01 0 1.5 1.5 0 0 0 3.01 0Zm10.17-1.51a1.5 1.5 0 1 1 0 3.02 1.5 1.5 0 0 1 0-3.02ZM7.67 15.25a1.5 1.5 0 1 0-3.01 0 1.5 1.5 0 0 0 3.01 0Zm10.17-1.5a1.5 1.5 0 1 1 0 3.01 1.5 1.5 0 0 1 0-3.01Z"/>
        </SvgIcon>
    )
}
